import { PiX } from 'react-icons/pi'
import { cn } from 'components/UI/cn'

/**
 * Filter chip — DS "Gray" badge (Tailwind). Pill shape, neutral fill, the
 * value rendered semibold. Exclusive ("NOT") filters use the error tint.
 *
 * The `data-filter-chip` attribute is kept so the DS2026 table surface
 * (`.fb-plain-links [data-filter-chip]` in main.css) can override this to the
 * green Primary badge on tables, while in-modal chips use the gray treatment.
 */
export function FilterChipContainer({
  $isExclusive,
  isHovered,
  className,
  children,
}: {
  $isExclusive?: boolean
  isHovered?: boolean
  className?: string
  children: React.ReactNode
}) {
  return (
    <span
      data-filter-chip="true"
      className={cn(
        'box-border inline-flex items-center gap-1.5 rounded-full px-3 py-1',
        'text-sm font-medium leading-5 tracking-[-0.2px]',
        '[&_b]:font-semibold',
        $isExclusive
          ? 'bg-error-bg-subtle text-error-strong'
          : 'bg-neutral-100 text-neutral-700',
        isHovered && !$isExclusive && 'bg-neutral-200',
        className
      )}
    >
      {children}
    </span>
  )
}

export function FilterChipCloseButton({
  $isExclusive,
  onClick,
  className,
  style,
}: {
  $isExclusive?: boolean
  onClick?: (e: React.MouseEvent<SVGElement>) => void
  className?: string
  style?: React.CSSProperties
}) {
  return (
    <PiX
      onClick={onClick}
      style={style}
      className={cn(
        'h-3.5 w-3.5 shrink-0 cursor-pointer rounded-full p-px transition-colors',
        $isExclusive
          ? 'text-error-strong hover:bg-error-border/40'
          : 'text-neutral-500 hover:bg-neutral-200',
        className
      )}
    />
  )
}
